var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"all-user-bookmarks"},[_c('h2',{staticClass:"title-with-underline"},[_vm._v(_vm._s(_vm.$t('bookmarks.yourBookmarks')))]),_c(_setup.GenericContent,{attrs:{"content":_setup.userBookmarks,"limit":_setup.limit}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }